<template>
  <div v-if="loading">
    <Spinner/>
  </div>
  <div v-else>
    <div v-if="currentExternalLink">
      <iframe id="iframe" :src="currentExternalLink" />
    </div>
    <div v-else>
      <p>Page not found</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
// this is also the 404 page!

import { computed, onMounted, ref } from 'vue';
import { useAuth } from "@/pinia/auth";
import { useTenant } from "@/plugins/tenant";
import { useRoute } from "vue-router";
import { useAxios } from "@/plugins/axios";
import Spinner from "@/components/Spinner.vue";


const auth = useAuth()
const route = useRoute()
const tenant = useTenant()
const axios = useAxios()

const loading = ref(false);

const currentExternalLink = ref('');

if (tenant.externalNavigationLinks.length > 0) {
  const linkObject = tenant.externalNavigationLinks.find(link => link.text == route.params.pathMatch[0]);
  if (linkObject) {
    currentExternalLink.value = linkObject.url;
  }
}

async function loadSuid() {
  loading.value = true;
  try {
    const response = await axios.get<string>(
      `/sso-profile/getSpektrumUserId`
    );
    loading.value = false;

    if (response.data.includes('Error:')) {
      console.log('Error getSpektrumUserId: '+response.data);
    } else {
      currentExternalLink.value = currentExternalLink.value.replace('-suid-', response.data);
    }
  } catch (error) {
    console.log('Error getSpektrumUserId: '+error);
  } finally {
    loading.value = false;
  }
}
if (auth.isFullyLoggedIn && currentExternalLink.value && currentExternalLink.value.includes('-suid-')) {
  loadSuid();
}
</script>

<style scoped>
  iframe {
    width: 100%;
    height: 100vh;
  }
</style>
